module.exports = __webpack_public_path__ + "img/wedding-dress-hanger.1bc0b899.png";